document.querySelectorAll('.js-username-input').forEach(container => {
  const email = container.dataset.email || '';
  const $input = container.querySelector('.username-input__input');
  const $recommendation = container.querySelector('.username-input__recommendation');
  const $applyButton = container.querySelector('button');

  const namePart = email.split('@')[0] || '';
  const readableName = namePart
    .replace(/[._-]+/g, ' ')
    .split(' ')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

  if ($recommendation) {
    $recommendation.textContent = readableName;
  }

  if ($applyButton && $input) {
    $applyButton.addEventListener('click', (event) => {
      event.preventDefault();

      $input.value = readableName;
    });
  }
});
